import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(id: string, putObject: Request): Promise<Optional<void>> {
	const url: string = `${SERVICEBASEURL.USER}/MailTemplate/${id}`;
	return axios.put(url, putObject).toOptionalVoid();
}

export interface Request {
	emailAccountId: string;
	localizedSubjects: {
		[key: string]: string;
	};
	localizedBodies: {
		[key: string]: string;
	};
	placeholders: string[];
}
